import React from 'react';
import { HOME } from '@ApplicationWide/routes/route-groups';
import { HOME_PAGE_TABS } from '../../../pages/HomePage/HomePageTabs/HomePageTabs';

const HomePage = React.lazy(() => import('../../../pages/HomePage'));
const PERMITTED_HOME_TAB_IDS = HOME_PAGE_TABS.map((x) => x.id).join('|');

export default {
  label: 'home-page.title',
  group: HOME,
  to: '/updates',
  route: ['/', `/:tabId(${PERMITTED_HOME_TAB_IDS})`, `/:tabId(${PERMITTED_HOME_TAB_IDS})/:userId`],
  component: HomePage,
  appearsInNavBar: true,
  hasNavBar: true,
};
